import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/xingxing.png'


const _withScopeId = n => (_pushScopeId("data-v-47902d12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainBody" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", { style: {"display":"flex","justify-content":"center"} }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("dd", { style: {"pne-height":"25px"} }, "购买须知")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "套餐购买须知:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, "1.物联网卡只允许使用在物联网设备上禁止放入手机使用。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " 2.物联网卡插入设备即机卡绑定，若更换设备卡将无法使用。 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, "3.流量套餐即充即用，用完即停，0月租费。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " 4.月底清零套餐每月仅生效一个套餐，不可叠加生效，按购买顺序逐月依次生效。 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " 5.跨月不清零套餐可跨月使用，每月可多次购买，按购买顺序依次生效。 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, "6.已成功购买的套餐，不可退不可换。", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " 7.设备仅限用于个人用途，禁止商业用途严禁用于违法犯罪活动，严禁P2P下载。 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " 8.设备采用运营商实名系统，通过实名认证后才能使用流量。 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " [月底清零] 和[跨月不清零] 套餐区别 :[月底清零]: 比如1月29号充值，2月1号流量清 零，需再次充值。 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item" }, " [跨月不清零]: 比如1月29号充值，下个月28号流量清零，30天为一个周期。 ", -1))

import { ref } from "vue";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'purchaseNotes',
  setup(__props) {

const activeIndex = ref(0);
let items = ref([{ text: "购买须知" }]);

function onCpckLeft() {
  console.log(1231);
  router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tree_select = _resolveComponent("van-tree-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "购买须知",
      "left-arrow": "",
      onClickLeft: onCpckLeft
    }),
    _createVNode(_component_van_tree_select, {
      "main-active-index": activeIndex.value,
      "onUpdate:mainActiveIndex": _cache[0] || (_cache[0] = ($event: any) => ((activeIndex).value = $event)),
      height: "100vh",
      items: _unref(items)
    }, {
      "nav-text": _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _: 1
    }, 8, ["main-active-index", "items"])
  ]))
}
}

})